export const dashboardApiHandler = {
  announcements: {
    getAnnouncements: {
      method: "GET",
      path: () => `org-announcements-management`,
      params: {} as {'filterDismissed'?: string | number, 'filterExpired'?: string | number, 'skip'?: string | number, 'take'?: string | number}
    },
    dismissAnnouncement: {
      method: "POST",
      path: (payload: { announcementId: string | number }) => `org-announcements-management/${payload.announcementId}/dismiss`
    }
  },
  financialSystem: {
    users: {
      addToCart: {
        method: "POST",
        path: (payload: { courseId: string | number }) => `orders/add/${payload.courseId}`
      },
      "create-test-order": {
        method: "POST",
        path: () => `orders/test-order`
      },
      "create-test-orderCopy": {
        method: "POST",
        path: (payload: { orderId: string | number }) => `orders/create-invoice/${payload.orderId}`
      },
      requestRefund: {
        method: "POST",
        path: (payload: { purchasedItemId: string | number }) => `orders/refund/${payload.purchasedItemId}`
      },
      getOrderById: {
        method: "GET",
        path: (payload: { orderId: string | number }) => `orders/${payload.orderId}`
      },
      getCart: {
        method: "GET",
        path: () => `orders/cart`
      },
      paymentDisclosure: {
        method: "POST",
        path: () => `orders/ottu-payment-disclosure`
      },
      checkout: {
        method: "POST",
        path: () => `orders/checkout`
      },
      checkoutTabby: {
        method: "POST",
        path: () => `orders/tabby-checkout`
      },
      checkoutTamara: {
        method: "POST",
        path: () => `orders/tamara-checkout`
      },
      walletCheckout: {
        method: "POST",
        path: () => `orders/wallet-checkout`
      },
      regenerateInvoice: {
        method: "POST",
        path: (payload: { orderId: string | number }) => `orders/regenerate-invoice/${payload.orderId}`
      },
      testInvoice: {
        method: "POST",
        path: (payload: { orderId: string | number }) => `orders/regenerate-invoice/${payload.orderId}`
      },
      removeItemFromCart: {
        method: "DELETE",
        path: (payload: { purchasedItemId: string | number }) => `orders/${payload.purchasedItemId}`
      },
      allOrders: {
        method: "GET",
        path: () => `orders/all`,
        params: {} as {'skip'?: string | number, 'take'?: string | number}
      },
      allOrdersPaginated: {
        method: "GET",
        path: () => `orders/all-v2`,
        params: {} as {'skip'?: string | number, 'take'?: string | number}
      },
      generateMoyasarCheckout: {
        method: "POST",
        path: () => `orders/moyasar/generate-checkout`
      },
      initializeMoyasarPayment: {
        method: "POST",
        path: () => `orders/moyasar/initialize-payment`
      },
      verifyMoyasarPayment: {
        method: "POST",
        path: () => `orders/moyasar/verify-payment`
      }
    },
    qoyod: {
      getAllCustomers: {
        method: "GET",
        path: () => `qoyod`
      },
      updateCustomer: {
        method: "PUT",
        path: () => `qoyod`
      },
      createInvoice: {
        method: "POST",
        path: () => `qoyod/create-invoice`
      },
      sendOrderInvoiceToQoyod: {
        method: "POST",
        path: (payload: { orderId: string | number }) => `orders/send-toqoyod/${payload.orderId}`
      },
      createQoyodInvoicePayment: {
        method: "POST",
        path: (payload: { qoyodInvoiceId: string | number }) => `orders/create-qoyod-invoicepayment/${payload.qoyodInvoiceId}`
      },
      createBulkInvoicePayments: {
        method: "POST",
        path: (payload: { startingInvoiceId: string | number }) => `orders/create-bulk-qoyod-invoicepayments/${payload.startingInvoiceId}`
      }
    },
    vouchers: {
      createVoucher: {
        method: "POST",
        path: () => `orders/create-voucher`
      },
      applyVoucher: {
        method: "POST",
        path: () => `orders/apply-voucher`
      },
      removeVoucher: {
        method: "POST",
        path: () => `orders/remove-voucher`
      }
    }
  },
  getStudentCourseStatistics: {
    method: "GET",
    path: (payload: { userId: string | number }) => `users/${payload.userId}/course-statistics`
  },
  getStudentUpcomingActivites: {
    method: "GET",
    path: (payload: { userId: string | number }) => `users/${payload.userId}/calendar`,
    params: {} as {'startTime'?: string | number, 'endingTime'?: string | number, 'completedFlag'?: string | number}
  },
  getEnrolledCoursesBasedOnProgress: {
    method: "GET",
    path: (payload: { userId: string | number }) => `users/${payload.userId}/enrolled-courses`,
    params: {} as {'skip'?: string | number, 'take'?: string | number}
  },
  getRecommendedCourses: {
    method: "GET",
    path: () => `courses`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'filterOutEnrolledCourses'?: string | number, 'availableUntilDate'?: string | number}
  }
};